import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  useTheme,
  Menu,
  MenuItem,Tooltip,
} from "@mui/material";
import { Close, Warehouse, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import CallAlertBar from "../../../Layout/Alertbar";
import AddUpdateWarehouseObjectTypeSize from "./AddUpdateWarehouseObjectTypeSize";
import { useNavigate } from "react-router-dom";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";
import { moduleHelpData } from "../../../data/moduleHelpData";
import HelpIcon from '@mui/icons-material/HelpOutline';

const WarehouseObjectTypeSizeMasterIndex = ({ handleBackWinderMachineEntry }) => {
  const [objectTypeList, setObjectTypeList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({
    object_type: "",
    object_length: "",
    object_width: "",
    object_height: "",
    object_unit: "",
    status: "",
  });
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // ✅ Menu state
  const [anchorElFirst, setAnchorElFirst] = useState(null);
  const [selectedOptionFirst, setSelectedOptionFirst] = useState("All Object List");

  const openFirst = Boolean(anchorElFirst);
  const handleMenuClickFirst = (event) => setAnchorElFirst(event.currentTarget);
  const handleMenuCloseFirst = () => setAnchorElFirst(null);

const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

const userPermissions = useUserPermissions();
 const handleMenuItemClickFirst = (option) => {
  setSelectedOptionFirst(option);
  handleMenuCloseFirst();

  // Reset all filters when switching list type
  setFilters({
    object_type: "",
    object_length: "",
    object_width: "",
    object_height: "",
    object_unit: "",
    status: "",
  });

  // Apply list filter
  if (option === "All Object List") {
    setFilteredList(objectTypeList);
  } else if (option === "Active Object List") {
    setFilteredList(objectTypeList.filter((x) => x.status === true));
  } else if (option === "Inactive Object List") {
    setFilteredList(objectTypeList.filter((x) => x.status === false));
  }
};


  // ✅ Load Data
  const LoadObjectTypeList = () => {
    const payload = {
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
    };

    callApi(
      Warehouse_API_ENDPOINTS.objectType.list,
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setObjectTypeList(data);
          setFilteredList(data);
        } else {
          setObjectTypeList([]);
          setFilteredList([]);
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No Object Type data found!");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setObjectTypeList([]);
        setFilteredList([]);
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Unable to load Object Type details");
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    LoadObjectTypeList();
  }, []);

  // ✅ Apply Filters
// useEffect(() => {
//   // Base list according to selected option
//   let baseList = objectTypeList;
//   if (selectedOptionFirst === "Active Object List") {
//     baseList = objectTypeList.filter(
//       (x) => x.status === true || (typeof x.status === 'string' && x.status.toLowerCase() === 'active')
//     );
//   } else if (selectedOptionFirst === "Inactive Object List") {
//     baseList = objectTypeList.filter(
//       (x) => x.status === false || (typeof x.status === 'string' && x.status.toLowerCase() === 'inactive')
//     );
//   }

//   // Apply column-wise filters
//   const filtered = baseList.filter((row) => {
//     const statusText =
//       typeof row.status === 'string'
//         ? row.status.toLowerCase()
//         : row.status === true
//         ? 'active'
//         : 'inactive';

//     const fObjectType = (filters.object_type || '').toLowerCase();
//     const fObjectLength = (filters.object_length || '').toString().toLowerCase();
//     const fObjectWidth = (filters.object_width || '').toString().toLowerCase();
//     const fObjectHeight = (filters.object_height || '').toString().toLowerCase();
//     const fObjectUnit = (filters.object_unit || '').toLowerCase();
//     const fStatus = (filters.status || '').toLowerCase();

//     return (
//       (row.object_type || '').toLowerCase().includes(fObjectType) &&
//       (row.object_length?.toString() || '').toLowerCase().includes(fObjectLength) &&
//       (row.object_width?.toString() || '').toLowerCase().includes(fObjectWidth) &&
//       (row.object_height?.toString() || '').toLowerCase().includes(fObjectHeight) &&
//       (row.object_unit || '').toLowerCase().includes(fObjectUnit) &&
//       statusText.includes(fStatus)
//     );
//   });

//   setFilteredList(filtered);
// }, [filters, objectTypeList, selectedOptionFirst]);
useEffect(() => {
  // Step 1: Base list according to menu selection
  let baseList = objectTypeList;

  if (selectedOptionFirst === "Active Object List") {
    baseList = objectTypeList.filter(
      (x) => x.status === true || (typeof x.status === 'string' && x.status.toLowerCase() === 'active')
    );
  } else if (selectedOptionFirst === "Inactive Object List") {
    baseList = objectTypeList.filter(
      (x) => x.status === false || (typeof x.status === 'string' && x.status.toLowerCase() === 'inactive')
    );
  }

  // Step 2: Apply filters
  const filtered = baseList.filter((row) => {
    // ✅ Normalize status text (true/false or string)
    const statusText =
      row.status === true || (typeof row.status === 'string' && row.status.toLowerCase() === 'active')
        ? 'active'
        : 'inactive';

    // ✅ Normalize filters
    const fObjectType = (filters.object_type || '').toLowerCase();
    const fObjectLength = (filters.object_length || '').toString().toLowerCase();
    const fObjectWidth = (filters.object_width || '').toString().toLowerCase();
    const fObjectHeight = (filters.object_height || '').toString().toLowerCase();
    const fObjectUnit = (filters.object_unit || '').toLowerCase();
    const fStatus = (filters.status || '').toLowerCase();

    // ✅ Apply filters
    return (
      (row.object_type || '').toLowerCase().includes(fObjectType) &&
      (row.object_length?.toString() || '').toLowerCase().includes(fObjectLength) &&
      (row.object_width?.toString() || '').toLowerCase().includes(fObjectWidth) &&
      (row.object_height?.toString() || '').toLowerCase().includes(fObjectHeight) &&
      (row.object_unit || '').toLowerCase().includes(fObjectUnit) &&
      statusText.startsWith(fStatus) // <-- fixed logic here
    );
  });

  setFilteredList(filtered);
}, [filters, objectTypeList, selectedOptionFirst]);


  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAdd = () => {
    setFormData({});
    setIsFormOpen(true);
  };

  const handleEdit = (row) => {
    const payload = {
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
      p_object_id: row.object_id,
    };

    callApi(
      Warehouse_API_ENDPOINTS.objectType.getById,
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setFormData(data[0]);
          setIsFormOpen(true);
        } else {
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No data found for selected Object Type");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Failed to fetch Object Type details");
        setAlertOpen(true);
      });
  };

  const handleExit = () => {
    handleBackWinderMachineEntry();
  };

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />
          <AppBar
            position="static"
            sx={{
              backgroundColor: "inherit",
              borderRadius: "0px",
              height: "48px",
              justifyContent: "center",
            }}
          >
            <Toolbar>
             {/* 🔽 Menu Below Title */}
          <Box >
            <Button
              color="secondary"
              onClick={handleMenuClickFirst}
              endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
              sx={{
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              {selectedOptionFirst}
            </Button>
            <Menu anchorEl={anchorElFirst} open={openFirst} onClose={handleMenuCloseFirst}>
              <MenuItem onClick={() => handleMenuItemClickFirst("All Object List")}>
                All Object List
              </MenuItem>
              <MenuItem onClick={() => handleMenuItemClickFirst("Active Object List")}>
                Active Object List
              </MenuItem>
              <MenuItem onClick={() => handleMenuItemClickFirst("Inactive Object List")}>
                Inactive Object List
              </MenuItem>
            </Menu>
          </Box>
{hasPermission(userPermissions,"Object type", "Create") && (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<Warehouse />}
                sx={{ ml: "auto", textTransform: "none" }}
                onClick={handleAdd}
              >
                New Object Type
              </Button>
)}


 <Tooltip title="View help document details" arrow>
                <IconButton
                  size="small"
                  aria-label="help"
                  sx={{ mx: 1 }}
                  onClick={handleHelpMenuClick}
                >
                  <HelpIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
              
              
                                      <ModuleHelpDialog
                                          open={helpOpen}
                                          onClose={handleCloseHelp}
                                          data={moduleHelpData.ObjectTypeMaster}
                                      />

              <IconButton onClick={handleExit}>
                <Close style={{ fontSize: "16px", color: "#2196F3" }} />
              </IconButton>
            </Toolbar>
          </AppBar>

          
          {/* Alerts */}
          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          {/* Table */}
          <Grid container padding={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  "& .MuiTableCell-root": {
                    border: "1px solid",
                    borderColor: `${colors.primary[400]} !important`,
                    padding: "6px",
                  },
                  maxHeight: "75vh",
                  overflowY: "auto",
                }}
              >
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Object Type</TableCell>
                        <TableCell>Length</TableCell>
                        <TableCell>Width</TableCell>
                        <TableCell>Height</TableCell>
                        <TableCell>Unit</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>

                      {/* 🔍 Filter Row */}
                      <TableRow>
                        {Object.keys(filters).map((key) => (
                          <TableCell key={key}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Search..."
                              fullWidth
                              value={filters[key]}
                              onChange={(e) =>
                                handleFilterChange(key, e.target.value)
                              }
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredList.map((obj) => (
                        <TableRow key={obj.object_id}>
                          <TableCell
                            sx={{
                              color: "teal",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handleEdit(obj)}
                          >
                            {obj.object_type}
                          </TableCell>
                          <TableCell>{obj.object_length}</TableCell>
                          <TableCell>{obj.object_width}</TableCell>
                          <TableCell>{obj.object_height}</TableCell>
                          <TableCell>{obj.object_unit}</TableCell>
                          <TableCell>
                            <Typography
                              sx={{
                                color: obj.status ? "" : "",
                                fontWeight: 600,
                              }}
                            >
                              {obj.status ? "Active" : "Inactive"}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {/* Add / Edit Form */}
      {isFormOpen && (
        <AddUpdateWarehouseObjectTypeSize
          formData={formData}
          setFormData={setFormData}
          setIsFormOpen={setIsFormOpen}
          LoadObjectTypeList={LoadObjectTypeList}
        />
      )}
    </Grid>
  );
};

export default WarehouseObjectTypeSizeMasterIndex;
